export default __webpack_public_path__ + "7cddaa91dad90b9392884afd17070efe.png";